<template>
  <div ref="buttonContainer">
    <!-- حالت دسکتاپ -->
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <v-speed-dial v-model="fab" direction="right">
        <template v-slot:activator>
          <v-btn
            v-b-tooltip.hover="'عملیات'"
            fab
            icon
            x-small
            @click.stop="fab = !fab"
          >
            <v-icon v-if="fab" color="pink darken-1 icon-xl-2x"
              >mdi-close</v-icon
            >
            <v-icon v-else class="icon-xl-2x" color="black"
              >mdi-dots-vertical</v-icon
            >
          </v-btn>
        </template>
        <v-btn
          v-for="(item, index) in meta.buttons"
          :key="index"
          v-b-tooltip.hover.top="getButtonLabel(item)"
          :class="classBtn + getButtonClass(item)"
          fab
          small
          @click.stop="item.action(data, item.name)"
        >
          <v-icon :class="iconClass + getButtonIcon(item)"></v-icon>
        </v-btn>
      </v-speed-dial>
    </div>

    <!-- حالت موبایل -->
    <div v-else class="mobile-buttons">
      <v-btn
        fab
        icon
        x-small
        @click.stop="fab = !fab"
        v-b-tooltip.hover="'عملیات'"
        class="mobile-activator"
      >
        <v-icon v-if="fab" color="pink darken-1 icon-xl-2x">mdi-close</v-icon>
        <v-icon v-else class="icon-xl-2x" color="black"
          >mdi-dots-vertical</v-icon
        >
      </v-btn>
      <v-expand-transition>
        <div v-if="fab" class="button-list">
          <v-btn
            v-for="(item, index) in meta.buttons"
            :key="index"
            v-b-tooltip.hover.left="getButtonLabel(item)"
            :class="classBtn + getButtonClass(item)"
            fab
            small
            @click.stop="item.action(data, item.name)"
            class="mobile-btn"
            >{{ getButtonLabel(item) }}
            <v-icon :class="iconClass + getButtonIcon(item)"></v-icon>
          </v-btn>
        </div>
      </v-expand-transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "manageButton",

  props: {
    data: {},
    action: {
      type: Function,
    },
    meta: {
      type: Object,
    },
  },

  data() {
    return {
      classBtn: "btn btn-sm text-center ",
      iconClass: "px-1 text-center icon-md mdi mdi-",
      fab: false,
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      const container = this.$refs.buttonContainer;
      if (this.fab && container && !container.contains(event.target)) {
        this.fab = false;
      }
    },
    getButtonLabel(item) {
      return item.label;
    },
    getButtonClass(item) {
      return item.class;
    },
    getButtonIcon(item) {
      return item.icon;
    },
  },
};
</script>

<style scoped>
.mobile-buttons {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mobile-activator {
  margin-bottom: 4px;
}

.button-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.mobile-btn {
  margin: 0 !important;
  width: 65px !important;
}
</style>
